const reservedProfileSlugs = new Set([
	'404',
	'a-propos',
	'account',
	'auth',
	'blog',
	'booking',
	'bureau-a-l-heure',
	'cart',
	'cleaning',
	'dashboard',
	'events',
	'extras',
	'favorites',
	'infos',
	'london',
	'lyon',
	'meeting-room',
	'mentions-legales',
	'offers',
	'office-by-the-hour',
	'office-space-by-the-hour',
	'on-site-qr',
	'overstays',
	'paris',
	'payment',
	'politique-confidentialite',
	'quotations',
	'reglement-cocoon',
	'salle-de-reunion',
	'scheduling',
	'unsubscribe',
	'use-cases',
	'venues',
])

export const isProfileSlugAvailable = (slug: string) =>
	!reservedProfileSlugs.has(slug.toLowerCase())

export const filterAvailableProfileSlugs = (slugs: string[]) =>
	slugs.filter(isProfileSlugAvailable)
